import {fetch} from "../../../utils/dataAccess";

export function deleteModel(model) {
    return new Promise((resolve, reject) => {
        fetch(model['@id'], {
            method: 'DELETE',
        }).then(() => {
            resolve(true)
        }).catch(error => reject(error));
    })
}